A set of questions presented to a candidate during an application.

This can be associated with one or more PositionProfiles when they are created.
